import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAverageStrain } from '../actions/strainAction';


export interface AverageStrainState {
  averageStrain: number | undefined;
  loading: boolean;
  error: string | null;
}

const initialState: AverageStrainState = {
  averageStrain: undefined,
  loading: false,
  error: ''
};

const averageStrainSlice = createSlice({
  name: 'averageStrain',
  initialState: initialState,
  reducers: {
    averageStrain: (state: AverageStrainState, action: PayloadAction<number>) => { 
      state.averageStrain = action.payload;
    }
  },
  extraReducers: (builder) => {
    // load averageRecovery
    builder.addCase(getAverageStrain.pending, (state: AverageStrainState) => {
        state.loading = true
        state.error = null
    }),
    builder.addCase(getAverageStrain.fulfilled, (state: AverageStrainState, { payload }: PayloadAction<number>) => {
        state.loading = false
        state.averageStrain = payload
    }),
    builder.addCase(getAverageStrain.rejected, (state: AverageStrainState, { payload }: PayloadAction<any>) => {
        state.loading = false
        state.error = payload
    })
  }
});

export const { averageStrain } = averageStrainSlice.actions;

export default averageStrainSlice.reducer;